import ConfigGraph from '@components/mxGraph/confiGraph';
import StyleGraph from '@components/mxGraph/styleGraph';
import { ComponentType } from '@interfaces/component-type';
import I18n from '@src/i18n';
import React from 'react';
import styled from 'styled-components';

interface IConfigProcessComponentProps {
  process: any;
  forceReload: boolean;
}

interface IConfigProcessComponentState {
  graph: any;
  layout: any;
  json: string;
  dragElt: any;
  createVisile: boolean;
  currentNode: any;
  currentTask: string;
  newProcess: any[];
  startVertex?: any;
  endvertex?: any;
  startEdge?: any;
  endEdge?: any;
}

export default class ComponentPreview extends React.Component<IConfigProcessComponentProps, IConfigProcessComponentState> {
  [x: string]: any;

  private _graph: any;
  private _style: any;

  constructor(props: any) {
    super(props);
    this.state = {
      graph: {},
      layout: {},
      json: "",
      dragElt: null,
      createVisile: false,
      currentNode: null,
      currentTask: "",
      newProcess: []
    };
  }

  componentDidMount = async () => {
    const config = new ConfigGraph();
    this._graph = config.previewConfig();
    this._style = new StyleGraph(this._graph);
    this._style.defaultStyle();
    this.LoadGraph();
  }



  UNSAFE_componentWillReceiveProps = async (nextProps: any) => {
    if ((this.props.process !== nextProps.process && this.props.process.length <= 10) || nextProps.forceReload) {
      this.setState({
         newProcess: nextProps.process 
        }, () => {
          this.LoadGraph();
        })
    }
  }

  LoadGraph = async () => {

    var parent = this._graph.getDefaultParent();
    this._graph.getModel().beginUpdate();
    this._graph.removeCells(this._graph.getChildVertices(this._graph.getDefaultParent()))
    const nodes = {}

    try {
      const process = this.props.process;
      this.setState({ graph: this._graph })
      const startVertex = this._graph.insertVertex(parent, null, I18n.l('label.pages.path.start'), 0, 0, 50, 50, "shape=ellipse;fillColor=#138A75;strokeColor=#138A75;fontColor=#ffffff");

      for (let p in process) {
        if (process[p].conditions && process[p].conditions.length > 0) {
          nodes[`${process[p].id}-condition`] = this._graph.insertVertex(parent, null, I18n.l('label.pages.path.conditions'), 0, 0, 93, 93, "shape=rhombus;rounded=1;fillColor=#FFF;strokeColor=#29CEAE;fontColor=#84A1AA")
        }
        const title = process[p].title.length > 10 ? `${process[p].title.substring(0, 10)}...` : process[p].title;
        nodes[`${process[p].id}`] = this._graph.insertVertex(parent, null, title, 0, 0, 93, 26, "rounded=1;fillColor=#FFF;strokeColor=#29CEAE;fontColor=#84A1AA")
      }
      const endvertex = this._graph.insertVertex(parent, null, I18n.l('label.pages.path.end'), 0, 0, 50, 50, "shape=ellipse;fillColor=#8A1313;strokeColor=#8A1313;fontColor=#ffffff");

      this.setState({ startVertex, endvertex })

      this._graph.insertEdge(parent, null, null, startVertex, nodes[`${process[0].id}`]);

      for (let p in process) {
        if (process[p].conditions && process[p].conditions.length > 0) {
          for (let condition of process[p].conditions) {
            this._graph.insertEdge(parent, null, '', nodes[`${process[p].id}-condition`], nodes[`${condition.sectionId}`]);
          }
          this._graph.insertEdge(parent, null, null, nodes[`${process[p].id}`], nodes[`${process[p].id}-condition`]);
          if (process[p].next !== null && process[p].next !== undefined) {
            this._graph.insertEdge(parent, null, null, nodes[`${process[p].id}-condition`], nodes[`${process[p].next}`]);
          }
          else if(!process[p].grouped) this._graph.insertEdge(parent, null, null, nodes[`${process[p].id}`], endvertex);
        } else {
          if (process[p].next !== null && process[p].next !== undefined) {
            this._graph.insertEdge(parent, null, null, nodes[`${process[p].id}`], nodes[`${process[p].next}`]);
          } else {
            if(!process[p].grouped){
              this._graph.insertEdge(parent, null, null, nodes[`${process[p].id}`], endvertex);
            }
          }
        }
      }

      for (let p in process) {
        const key = parseInt(p)
        if (process[key].components) {
          for (let component of process[key].components) {
            if (component.type === ComponentType.GOTO || component.type === ComponentType.SAMPLE) {
              for (let o of component.options) {
                const todoPage = process.findIndex((item: any) => item.id === o.sectionId)
                if (process[todoPage - 1]) {
                }
                this._graph.insertEdge(parent, null, null, nodes[`${process[p].id}`], nodes[`${o.sectionId}`], "dashed=1;strokeColor=#1890ff;backgroundColor: #ffffff");
              }
            }
          }
        }
      }
    } finally {
      this.setState({ newProcess: this.props.process })
      this._graph.getModel().endUpdate();
    }

    const layout = this._style.setLayout(parent)
    this.setState({ layout: layout, graph: this._graph })
  };

  render() {
    return (
      <PreviewComponent>
        <div id="graphContainer" />
      </PreviewComponent>
    );
  }
}

const PreviewComponent = styled.div`
  height: 75vh;
  width: 100%;
  overflow-y: auto;
  #graphContainer {
    margin: 0 auto
  }
  ::-webkit-scrollbar {
    width: 10px;
  }
  
  ::-webkit-scrollbar-track {
    background: #f1f1f1; 
  }
   
  ::-webkit-scrollbar-thumb {
    background: #888; 
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #555; 
  }
`;
